module.exports = __webpack_public_path__ + "img/logo_procu.a1d6f0b6.png";